import TimeOffset from '../TimeOffset';
import { TriggerFieldInputProps } from '../types';
import ExoField from './ExoField';

const NumberField = ({
    option,
    id,
    value,
    onChange,
    type,
    autoComplete,
    showValidation,
    validationMessage,
}: TriggerFieldInputProps) => {
    return option.id === 'timeoffset' ? (
        <TimeOffset id={id} option={option} value={value as number} onChange={onChange} />
    ) : (
        <ExoField
            id={id}
            option={option}
            value={value}
            onChange={onChange}
            type={type}
            autoComplete={autoComplete}
            showValidation={showValidation}
            validationMessage={validationMessage}
        />
    );
};

export default NumberField;
